<template>
  <tbody>
    <tr
      v-for="row in rowNum"
      :key="row">
      <td
        v-for="col in colNum"
        :key="col"
        class="placeholder">
        <div class="bar"
             :style="`width: ${Math.floor(Math.random() * 51) + 40}%;`" />
      </td>
    </tr>
  </tbody>
</template>

<script>
  export default {
    name: 'PlaceHolderTableBody',
    props: {
      rowNum: {
        type: Number,
        default: 3
      },
      colNum: {
        type: Number,
        default: 3
      }
    },
  }
</script>

<style scoped>

  @keyframes loading {
    40% {
      background-position: 100% 0;
    }
    100% {
      background-position: 100% 0;
    }
  }

  .placeholder {
    position: relative;
  }
  .placeholder .bar {
    background-color: #212529;
    height: 1rem;
    border-radius: .5rem;
    opacity: .2;
  }
  .placeholder:after {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    left: 0;
    content: "";
    display: block;
    width: 100%;
    height: 2rem;
    background-image: linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 80%);
    background-size: 200px 2rem;
    background-position: -100px 0;
    background-repeat: no-repeat;
    animation: loading 1s infinite;
  }

</style>
